/* eslint-disable i18next/no-literal-string */
const MercadoPagoLogo = (
    props: React.ImgHTMLAttributes<HTMLImageElement>
): React.ReactElement => {
    return (
        <img src="/mercado-pago-logo.webp" alt="mercado-pago-logo" {...props} />
    )
}

export default MercadoPagoLogo
